module.exports = __webpack_public_path__ + "img/fca6_en.a4637ae7.png";